module.exports = __webpack_public_path__ + "static/media/tictactoeBoard_lg.3c5ce6a6.svg";